/* src/app/order/components/current-certification-body-questions/current-certification-body-questions.style.scss */
.company-input-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  display: block;
  text-transform: uppercase;
}
.redirection-message {
  font-size: 15px;
  font-weight: bold;
  line-height: 24px;
  color: #ee7f00;
}
.redirection-message a {
  color: #ee7f00;
}
nb-radio {
  display: inline-block !important;
}
.form-row .cb-select {
  flex-wrap: nowrap;
  min-width: 180px;
}
.form-row .other-cb {
  width: 100%;
}
.form-row.custom-cb {
  flex-wrap: wrap;
}
.form-row.custom-cb input {
  text-overflow: ellipsis;
}
@media screen and (min-width: 992px) and (max-width: 1279px) {
  .wrap {
    flex-flow: wrap;
  }
}
/*# sourceMappingURL=current-certification-body-questions.style.css.map */
